export const animateInputPlaceholder = async (
  newText: string,
  inputElement: HTMLInputElement | null,
  duration: number,
  callback: () => void,
) => {
  const current: { frame: any } = { frame: 0 };
  const currentText = inputElement?.placeholder || '';
  let i = 0;
  let x = currentText.length;
  const speed = duration / (currentText.length + newText.length);

  function type() {
    if (inputElement) {
      inputElement.placeholder = newText.substring(0, i);

      if (i < newText.length) {
        i += 1;
        current.frame = setTimeout(type, speed);
      } else {
        callback();
      }
    }
  }

  function eraseText() {
    if (inputElement) {
      inputElement.placeholder = currentText.substring(0, x);

      if (x > 0) {
        x -= 1;
        current.frame = setTimeout(eraseText, speed);
      } else {
        type();
      }
    }
  }

  eraseText();

  return current;
};

export default animateInputPlaceholder;
